import { useTranslation } from 'react-i18next';

export default function Testimonials() {
  const { t } = useTranslation();

  const testimonials = [
    {
      nameKey: 'client1Name',
      roleKey: 'client1Role',
      contentKey: 'client1Content',
      rating: 5,
      image: "https://public.readdy.ai/ai/img_res/5a555ff68ad9548b68637f250b65d940.jpg"
    },
    {
      nameKey: 'client2Name',
      roleKey: 'client2Role',
      contentKey: 'client2Content',
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20restaurant%20owner%2C%20warm%20smile%2C%20traditional%20yet%20modern%20restaurant%20background%2C%20friendly%20approachable%20style&width=300&height=300&seq=client002&orientation=squarish"
    },
    {
      nameKey: 'client3Name',
      roleKey: 'client3Role',
      contentKey: 'client3Content',
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20construction%20company%20owner%2C%20hard%20hat%20and%20business%20attire%2C%20construction%20site%20background%2C%20reliable%20and%20trustworthy%20appearance&width=300&height=300&seq=client003&orientation=squarish"
    },
    {
      nameKey: 'client4Name',
      roleKey: 'client4Role',
      contentKey: 'client4Content',
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20holding%20permanent%20residence%20card%2C%20happy%20expression%2C%20modern%20office%20background%2C%20success%20story%20style&width=300&height=300&seq=client004&orientation=squarish"
    },
    {
      nameKey: 'client5Name',
      roleKey: 'client5Role',
      contentKey: 'client5Content',
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20logistics%20company%20owner%2C%20confident%20pose%2C%20trucks%20and%20warehouse%20background%2C%20successful%20business%20owner%20style&width=300&height=300&seq=client005&orientation=squarish"
    },
    {
      nameKey: 'client6Name',
      roleKey: 'client6Role',
      contentKey: 'client6Content',
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20with%20Japanese%20citizenship%20certificate%2C%20proud%20and%20happy%20expression%2C%20modern%20office%20setting%2C%20achievement%20moment&width=300&height=300&seq=client006&orientation=squarish"
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            {t('testimonialsTitle')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image} 
                  alt={t(testimonial.nameKey)}
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <h3 className="font-bold text-slate-800 text-lg">{t(testimonial.nameKey)}</h3>
                  <p className="text-slate-600 text-sm">{t(testimonial.roleKey)}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>
              
              <p className="text-slate-700 leading-relaxed italic">
                "{t(testimonial.contentKey)}"
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-white rounded-2xl p-8 max-w-4xl mx-auto shadow-lg">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="w-24 h-24 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-translate-2 text-white text-3xl"></i>
              </div>
              <div className="text-left">
                <h3 className="text-2xl font-bold text-slate-800 mb-3">
                  {t('chineseStaffTitle')}
                </h3>
                <p className="text-slate-600 leading-relaxed mb-4">
                  {t('chineseStaffDesc')}
                </p>
                <div className="flex flex-wrap gap-2">
                  <span className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-sm font-medium">{t('tag1')}</span>
                  <span className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-sm font-medium">{t('tag2')}</span>
                  <span className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-sm font-medium">{t('tag3')}</span>
                  <span className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-sm font-medium">{t('tag4')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
